var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.channels.length > 0)?_c('div',[_c('PageHeader',{attrs:{"logo":_vm.productCategory}}),_vm._v(" "),_c('GridHolder',{staticClass:"header-margin"},[_c('ChannelGrid',{attrs:{"channels":_vm.channels,"paper-items":_vm.paperItems}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }